import { Outlet } from 'react-router-dom';
import { CandidateAuthProvider } from './CandidateAuthContext';

/** A single real provider for every /careers/* page, rather than repeating CandidateAuthProvider per page. */
export function CareersLayout() {
  return (
    <CandidateAuthProvider>
      <Outlet />
    </CandidateAuthProvider>
  );
}
